
      import TelephoneFill from './telephone-fill.vue'
      import type { App, Plugin } from 'vue'

      export const TelephoneFillPlugin: Plugin = {
        install(app: App) {
          app.component('TelephoneFill', TelephoneFill)
        },
      }
      export { TelephoneFill }
      